import React from 'react'
import ClassNote from '../pure/classNote'

function notesListContainer({NotesList}) {
  return (
    <div className='gap-3'>
      {
        NotesList !==""?
        <div className='d-flex flex-column gap-2'>
          {
            NotesList.map(
              (item,i) => {
                return(<ClassNote 
                  key={i}
                  name={item.archiveName} 
                  user={item.user} 
                  date={item.year} 
                  download={item.archiveURL}/>
                )
              }
            )
          }
        </div>
        :
        <div className="d-flex flex-column align-items-center justify-content-center">
          <div class="spinner-grow text-success" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
       </div>
      }


    </div>
  )
}

export default notesListContainer